export const WatchLater = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Watch Later</h1>
        </div>
    )
}